module.exports = __webpack_public_path__ + "img/handover_car.9fe2c52f.jpg";